export enum PathType {
	Tier,
	CalculationMethod
}

export const isTopLevelPath = (path: string) => path.split(".").length === 1 && !path.includes("*");
export const isCalculationMethodPath = (path: string) => /^calculationMethod\.[A-Za-z0-9_]+$/.test(path);
export const isTierPath = (path: string) => /^tiers\.(?:\*|\d+)\.[A-Za-z0-9_]+$/.test(path);

export const getKeyFromPath = (type: PathType, path: string) => {
	if (type === PathType.Tier) {
		const segments = path.split(".");
		return segments[2]; // tiers.*.key
	} else {
		const segments = path.split(".");
		return segments[1]; // calculationMethod.price
	}
};
